export const NAMESPACE = 'toasts'
